import { section } from "@/neon";
import mobileCarousel from "@/lib/mobile-carousel";

const sel = {
  slider: "[data-slider]",
};

section("gallery", {
  onLoad() {
    const slider = this.container.querySelector(sel.slider);
    this.mobileCarousel = mobileCarousel(slider);
  },

  onUnload() {
    this.mobileCarousel.destroy();
  },

  onBlockSelect({ target }) {
    this.mobileCarousel.select(target.dataset.index);
  },
});
